// 配置引导环节, 后端定义, 有缺的不准确的可以调整
export enum Steps {
  WELCOME_MESSAGE = 'WELCOME_MESSAGE', // 进店欢迎语
  AUTO_REPLY_ON_TIMEOUT = 'AUTO_REPLY_ON_TIMEOUT', // 超时自动回复
  PROMPT_ORDER = 'PROMPT_ORDER', // 催下单
  PROMPT_PAYMENT = 'PROMPT_PAYMENT', // 催付款
  PROMPT_POSITIVE_REVIEW = 'PROMPT_POSITIVE_REVIEW', // 催好评
  ACTIVITY_START_PAGE = 'ACTIVITY_START_PAGE', // 活动开始页
  FLASH_SALE_EVENT = 'FLASH_SALE_EVENT', // 闪购活动
  PRODUCT_DISCOUNT = 'PRODUCT_DISCOUNT', // 商品折扣
  RECOMMENDED_HOT_ITEMS = 'RECOMMENDED_HOT_ITEMS', // 推荐爆款
  AI_MODEL_LOGISTICS = 'AI_MODEL_LOGISTICS',
  AI_MODEL_STORE = 'AI_MODEL_STORE',
  SHIPPING_DAYS = 'SHIPPING_DAYS', // 发货天数
  LOGISTICS_CARE = 'LOGISTICS_CARE', // 物流呵护
  ABANDONED_CART_RECOVERY = 'ABANDONED_CART_RECOVERY', // 弃单挽回
  REVIEW_MANAGEMENT = 'REVIEW_MANAGEMENT', // 评价管理
  MARKETING_WELCOME = 'MARKETING_WELCOME',
}

export const BasicCircle = Object.values(Steps).slice(0, 9);
export const ActivityCircle = BasicCircle.slice(5);
export const AiModelCircle = Object.values(Steps).slice(9, 11);
export const AdvancedCircle = Object.values(Steps).slice(12, 15);

export const MarketingCircle = Object.values(Steps).slice(15, 16);
export const AiAssistantBotCircle = Object.values(Steps).slice(9, 11);
export const AiSaleBotCircle = Object.values(Steps).slice(2, 9);
export const AiSaleBotAdvancedCircle = Object.values(Steps).slice(12, 15);
